/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 支付宝小程序定制化首页
 */
import { namespace } from 'vuex-class';
import { Component, InjectReactive, Mixins } from 'vue-property-decorator';

import { PullRefresh } from 'vant';

import HomeBottomBar from '@/components/home-bottom-bar';
import IdenttityScoreMixins from '@/mixins/finance-identity';
import isPrerendering from '@/shared/utils/isPrerendering';
import { Visit } from '@/enums/tianjiangConf';
import { BannerClickActionEnums, HomeThemeEnums, getHomeThemeBodyConfig } from '@/shared/utils/pageTheme';
import FinanceBusiness from '@/mixins/finance-business';
import { ubtSendError } from '@/shared/utils/ubt';
import { OcrProcessSourceEnum } from '@/shared/tools/ocr/enum';
import { agreementService } from '@/service/confirm-agreements';
import BrandGuide from '../../components/brand-guide';
import QualityNewFinanceCard from '../../components/finance-quality-card';
import RiskStatement from '../../components/risk-statement';
import type { Home } from '../../types';
import ThemeBanner from '../../components/theme-banner';

// 天降红包
const RedPacket = () => import(
  /* webpackChunkName: "red-packet" */'../../components/red-packet'
) as any;

const HomeStore = namespace('home');
const _isPrerendering = isPrerendering();
const style: Dictionary = require('./index.module.scss');

@Component
export default class AliminiQualityHome extends Mixins(
  IdenttityScoreMixins,
  FinanceBusiness,
) {
  @InjectReactive() homePage!: Home;

  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.State homeThemeType!: HomeThemeEnums;

  private isRefresh = false

  private created() {
    if (!_isPrerendering) {
      if (this.homePage && this.homePage.shouldCorrectRouteByCredit()) {
        this.homePage.correctRouteByCredit();
      } else {
        // 预加载协议数据
        agreementService.preloadAgreementsData();
        this.updatedIdentityScore(OcrProcessSourceEnum.HOME);
      }
    }
  }

  private mounted() {
    if (_isPrerendering) {
      document.dispatchEvent(new Event('render-event'));
    }

    if (this.homePage) {
      this.homePage.hideLoading();
    }
  }

  // 下拉刷新
  private onRefresh() {
    this.getCreditData().then(() => {
      this.isRefresh = false;
    });
  }

  private onThemeBannerClick(action?: string) {
    if (action === BannerClickActionEnums.JUMP_TO_APPLY_PRODUCT) {
      this.onApplyProduct('finance_quality_promote_loan');
    } else if (action === BannerClickActionEnums.JUMP_TO_CREDIT) {
      this.onApplyCredit('finance_quality_promote_credit');
    } else {
      ubtSendError('ThemeBannerClick Invalid Action');
    }
  }

  private render() {
    const themeBannerConfig = getHomeThemeBodyConfig(this.homeThemeType, this.$route.name);
    const { isValidTheme, bgTransitionStyle, clickAction } = themeBannerConfig;

    return (
      <div
        class={[style.aliminiHomeContainer, isValidTheme && style.customeThemeBox]}
        style={isValidTheme && bgTransitionStyle}>
        {isValidTheme
          ? (
            <ThemeBanner
              themeConfig={themeBannerConfig}
              onThemeBannerClick={() => this.onThemeBannerClick(clickAction)}
            />)
          : <div class={style.gradientBackground} />}
        <RedPacket
          visit={Visit.Quality}
        />
        <PullRefresh
          v-model={this.isRefresh}
          onRefresh={this.onRefresh.bind(this)}
          disabled={true}
        >
          <QualityNewFinanceCard ref="financeCard" userCreditData={this.creditData}/>
          <BrandGuide />
          <RiskStatement />
          <div class={style.safeArea}></div>
        </PullRefresh>

        <HomeBottomBar />
      </div>
    );
  }
}
